import { useMemo } from 'react'

import type { OrchestratedQuote } from '@b-stock/fe-core/bstock-next/queries'

export type CalculatedAdditionalCharges = {
  /**
   * basis in dollars
   */
  basis: number
  /**
   * total in cents
   */
  total: number
  isWithoutShipping: boolean
  /**
   * bstockFee in cents
   */
  bstockFee: number
}

export type UseCalculatedAdditionalChargesProps = {
  /**
   * buyersPremium is a number between 0 and 100 representing a percentage
   * We call it buyersPremium and not buyerPremium to match ActiveServiceDto
   */
  buyersPremium: number
  currentBidDollars: number
  selectedQuote?: OrchestratedQuote | null
}

export const useCalculatedAdditionalCharges = ({
  buyersPremium,
  currentBidDollars,
  selectedQuote,
}: UseCalculatedAdditionalChargesProps): CalculatedAdditionalCharges => {
  return useMemo(() => {
    const bstockFee = currentBidDollars * buyersPremium
    const total = (selectedQuote?.totalPrice ?? 0) + bstockFee
    return {
      /**
       * basis in dollars
       */
      basis: currentBidDollars,
      /**
       * total in cents
       */
      total,
      isWithoutShipping: !selectedQuote,
      /**
       * bstockFee in cents
       */
      bstockFee,
    }
  }, [currentBidDollars, selectedQuote, buyersPremium])
}
